import { Pages } from 'modules/navigation/domain/enums/pages';
import { ChampionshipEncoded } from 'modules/championship/domain/interfaces/championship-encoded';
import React, { useCallback, useEffect, useMemo } from 'react';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import ChampionshipCreateForm from 'modules/championship/ui/components/create-form';

const ChampionshipCreatePage = () => {
  const onSave = useCallback((_: Partial<ChampionshipEncoded>) => {}, []);
  const { setHeaderContent } = useMainLayout();

  const breadcrumbsItems = useMemo(() => {
    return [
      {
        label: 'Создание турнира',
        to: Pages.CHAMPIONSHIPS.CREATE,
      },
    ];
  }, []);

  const breadcrumbs = useMemo(() => <UDBreadcrumbs className="my-10" breadcrumbs={breadcrumbsItems} />, [breadcrumbsItems]);

  useEffect(() => {
    setHeaderContent(breadcrumbs);

    return () => {
      setHeaderContent(null);
    };
  }, [breadcrumbs, setHeaderContent]);

  return <ChampionshipCreateForm onSubmit={onSave} />;
};

export default ChampionshipCreatePage;
